import type { Catalog } from "../en";

export const team: Catalog["team"] = {
  title: "Team",
  subtitle: "Ang mga tao sa {{workspace}} na namamahala sa mga assistant, sumasagot sa mga handoff at tumitingin ng analytics.",
  search: "Maghanap ng miyembro…",
  manageRoles: "Mga role at permission",
  members: "Mga miyembro",
  all: "Lahat",
  pending: "Nakabinbin",
  colMember: "Miyembro",
  colRole: "Role",
  colTeams: "Mga team",
  col2fa: "2FA",
  colLastActive: "Huling aktibo",
  colActions: "Mga aksyon",
  you: "(ikaw)",
  twoFaEnabled: "Naka-on",
  twoFaMissing: "Hindi pa naka-set up",
  pendingInvite: "Nakabinbing imbitasyon",
  never: "Hindi pa",
  now: "Ngayon",
  noTeams: "—",
  invitedBy: "Inimbitahan ni {{name}} · {{date}} · mag-e-expire {{expires}}",
  invitedOn: "Inimbitahan {{date}} · mag-e-expire {{expires}}",
  roleSelect: "Role ni {{name}}",
  ownerLocked: "Ilipat ang pagmamay-ari sa Settings",
  ownRoleLocked: "Hindi mo mababago ang sarili mong role",
  roleChanged: "{{role}} na si {{name}}",
  multipleRoles: "{{count}} role",
  editRoles: "I-edit ang mga role",
  remove: "Alisin",
  leave: "Umalis sa workspace",
  removeTitle: "Alisin si {{name}}?",
  removeBody: "Agad siyang mawawalan ng access sa {{workspace}}. Babalik sa pila ng kanyang team ang mga bukas na handoff na nakatalaga sa kanya. Mananatili ang kanyang audit log.",
  leaveTitle: "Umalis sa {{workspace}}?",
  leaveBody: "Agad kang mawawalan ng access. Kailangang laging may kahit isang Owner ang workspace.",
  removed: "Inalis si {{name}} sa workspace",
  left: "Umalis ka na sa {{workspace}}",
  cancel: "Kanselahin",
  emptyTitle: "Walang tugmang miyembro",
  emptyBody: "Subukan ang ibang pangalan o email.",
  emptyPendingTitle: "Walang nakabinbing imbitasyon",
  emptyPendingBody: "Dito lalabas ang mga ipinadala mong imbitasyon hanggang tanggapin ang mga ito.",
  loadError: "Hindi ma-load ang mga miyembro.",
  rolesDialogTitle: "Mga role ni {{name}}",
  rolesDialogBody: "Magdagdag ng isa o higit pang role, bawat isa may sariling saklaw.",
  addAssignment: "Magdagdag ng role",
  removeAssignment: "Alisin",
  saveRoles: "I-save ang mga role",
  chooseRole: "Role",
  rolesSaved: "Na-update ang mga role ni {{name}}",
  inviteMembers: "Mag-imbita ng miyembro",
  viewActivity: "Tingnan ang aktibidad",
  resendInvite: "Ipadala muli ang imbitasyon",
  inviteResent: "Muling naipadala ang imbitasyon kay {{email}}",
  revokeInvite: "Bawiin ang imbitasyon",
  inviteRevoked: "Nabawi ang imbitasyon para kay {{email}}",
  inviteActions: "Mga aksyon para sa imbitasyon ni {{email}}",
  seats: {
    title: "{{used}} sa {{limit}} seat ang gamit sa {{plan}}",
    titleUnlimited: "{{used}} seat ang gamit sa {{plan}}",
    full: "Gamit na ang lahat ng seat. Kailangan ng bakanteng seat bago makasali ang bagong miyembro.",
    pendingNeedsSeat_one: "{{count}} nakabinbing imbitasyon ang nangangailangan ng bakanteng seat bago ito matanggap.",
    pendingNeedsSeat_other: "{{count}} nakabinbing imbitasyon ang nangangailangan ng bakanteng seat bago matanggap.",
    available_one: "{{count}} seat ang bakante.",
    available_other: "{{count}} seat ang bakante.",
    meterLabel: "Mga seat na gamit",
    pricePerSeat: "{{price}}/seat/buwan",
    pricePerSeat_year: "{{price}}/seat/taon",
    addSeats: "Magdagdag ng seat",
    addSeatsTitle: "Magdagdag ng seat",
    extraSeats: "Dagdag na seat",
    perSeat: "Bawat seat",
    perMonth: "{{price}} / buwan",
    perYear: "{{price}} / taon",
    orUpgrade: "O i-upgrade ang plano",
    seePlans: "Tingnan ang mga plano",
    totalMonthly: "Idadagdag sa inyong bill",
    chargedNow: "Sisingilin ngayon",
    chargedNowDays: "Sisingilin ngayon ({{days}} sa {{total}} araw ang natitira)",
    seatsAdded_one: "Nadagdag ang {{count}} seat. Prorated ito sa susunod ninyong invoice.",
    seatsAdded_other: "Nadagdag ang {{count}} seat. Prorated ang mga ito sa susunod ninyong invoice.",
    noBillingAccess: "Hilingin sa isang Owner na magdagdag ng seat.",
  },
  invite: {
    title: "Mag-imbita ng miyembro",
    seatWarningLead: "Gamit na ang lahat ng {{limit}} seat. Idinadagdag ang bagong miyembro sa halagang",
    seatWarningTail: "prorated sa susunod ninyong invoice.",
    emails: "Mga email address",
    emailsPlaceholder: "pangalan@inyongorganisasyon.com, iba@inyongorganisasyon.com",
    emailsHint: "Paghiwalayin gamit ang kuwit o bagong linya.",
    emailsHintDomains: "Paghiwalayin gamit ang kuwit o bagong linya. {{domains}} lang ang pinapayagang address (Settings → Security).",
    emailsRequired: "Magdagdag ng kahit isang email address",
    emailsInvalid: "Suriin ang mga address na ito: {{emails}}",
    emailsTooMany: "Hanggang {{max}} tao lang ang maiimbita nang sabay",
    emailsCount_one: "{{count}} tao ang iimbitahan",
    emailsCount_other: "{{count}} tao ang iimbitahan",
    role: "Role",
    roleDescriptions: {
      admin: "Lahat maliban sa billing at pagbura ng workspace.",
      editor: "Nag-a-upload ng dokumento, nag-e-edit ng instructions ng assistant at sumasagot sa mga kakulangan sa kaalaman.",
      agent: "Sumasagot sa mga handoff sa Inbox para sa kanilang team. Hindi makakapagbago ng kaalaman o settings.",
      viewer: "Read-only na access sa analytics at mga usapan, para sa pamunuan.",
      field_engineer: "Gumagawa sa mga ticket at pagbisita ng kanilang team at nag-uulat mula sa field.",
      sales: "Gumagawa sa mga quote at order ng mga organisasyon ng kliyente at sa mga ticket ng kanilang team.",
      custom: "Custom na role · {{count}} permission",
    },
    team: "Team",
    noTeam: "Walang team",
    message: "Mensahe",
    messagePlaceholder: "Hi! Sumali sa aming workspace para makatulong sa pagsagot ng mga tanong.",
    send: "Ipadala ang mga imbitasyon",
    sent_one: "Naipadala ang imbitasyon sa {{count}} tao. Makakatanggap sila ng email mula sa {{product}}.",
    sent_other: "Naipadala ang mga imbitasyon sa {{count}} tao. Makakatanggap sila ng email mula sa {{product}}.",
    skipped: "Nilaktawan (miyembro na o naimbitahan na): {{emails}}",
    noPermission: "Hilingin sa isang Owner o Admin na mag-imbita.",
  },
  rolesCard: {
    title: "Mga role at permission",
    subtitle: "Ang magagawa ng bawat built-in na role sa workspace na ito",
    manage: "Pamahalaan ang mga role",
    permission: "Permission",
    allowed: "Pinapayagan",
    notAllowed: "Hindi pinapayagan",
    rows: {
      billing_manage: "Pamahalaan ang billing",
      team_manage: "Pamahalaan ang team",
      knowledge_edit: "I-edit ang kaalaman",
      agents_edit: "I-edit ang settings ng agent",
      inbox_reply: "Tingnan ang inbox at sumagot",
      analytics_view: "Tingnan ang analytics",
      api_keys_manage: "Pamahalaan ang API keys",
    },
    loadError: "Hindi ma-load ang mga role.",
  },
  teams: {
    title: "Mga team",
    newTeam: "Bagong team",
    editTeam: "I-edit ang {{name}}",
    membersOf: "Mga miyembro ng {{name}}",
    noMembers: "Wala pang miyembro",
    emptyTitle: "Wala pang team",
    emptyBody: "Ipinapasa ng mga team ang handoff sa tamang tao, gaya ng Front desk o Billing.",
    loadError: "Hindi ma-load ang mga team.",
    routingTitle: "Pagruruta ng handoff:",
    routingRule: "ang {{topics}} ay mapupunta sa {{team}}",
    routingBody: "kapag humingi ng tao ang bisita, pinipili ng AI ang team ayon sa paksa: {{rules}}.",
    routingNone: "magdagdag ng paksa sa isang team para maipasa rito ng AI ang mga handoff. Napupunta sa shared inbox ang mga hindi nairuta.",
    routing: {
      toTeam: "mapupunta ang mga handoff sa {{name}} team.",
      toPerson: "mapupunta ang mga handoff kay {{name}}.",
      toFallback: "walang itinakdang team o tao, kaya mapupunta ang mga handoff sa Owner at mga Admin.",
      payment: "Ang mga tanong tungkol sa bayad ay mapupunta sa {{name}} team.",
      topicsOff: "Nakapatay ang pagtutugma ng paksa.",
      topicRules: "Ang team na tumutugma ang paksa ang unang makakakuha ng chat: {{rules}}.",
      noTopics: "Walang team na may paksa ng pagruruta, kaya sa default na target sa itaas mapupunta ang lahat ng handoff.",
      queue: "Iisang pila ang team (ang unang sumagot ang may-ari ng chat) maliban kung naka-on ang round-robin, na ibinibigay ang bawat chat sa miyembrong pinakakaunti ang bukas na chat.",
    },
    traits: {
      roundRobin: "Round-robin",
      queue: "Iisang pila",
      lead: "Lead: {{name}}",
      email: "Mailbox: {{email}}",
    },
    notifyEmail: "Email ng team",
    notifyEmailHint: "Opsyonal. Ipapadala rin sa address na ito ang bawat handoff ng team at ang mga paalala nito.",
    notifyEmailInvalid: "Maglagay ng wastong email address",
    lead: "Lead ng team",
    leadHint: "Opsyonal. Makakatanggap ng paalala kapag hindi nakasagot ang team sa takdang oras. Pumili mula sa mga miyembro sa itaas.",
    noLead: "Walang lead",
    confirmDeleteTitle: "Buburahin ang {{name}} team?",
    confirmDeleteBody: "Mananatili sa inbox nang walang team ang mga chat na naghihintay sa team na ito, at babalik sa Owner at mga Admin ang mga agent na rito nagruruta ng handoff. Hindi na ito maibabalik.",
    confirmDelete: "Burahin ang team",
    editRouting: "I-edit ang mga patakaran sa pagruruta",
    name: "Pangalan ng team",
    namePlaceholder: "hal. Front desk",
    nameRequired: "Bigyan ng pangalan ang team",
    description: "Paglalarawan",
    descriptionPlaceholder: "Ano ang hinahawakan ng team na ito",
    topics: "Iruta ang mga handoff tungkol sa",
    topicsPlaceholder: "billing, appointment, reklamo",
    topicsHint: "Mga paksang ginagamit ng AI para piliin ang team na ito. Paghiwalayin gamit ang kuwit.",
    members: "Mga miyembro",
    membersPlaceholder: "Pumili ng miyembro",
    membersSearch: "Maghanap ng miyembro…",
    membersEmpty: "Walang tugmang miyembro",
    membersSelected_one: "{{count}} miyembro",
    membersSelected_other: "{{count}} miyembro",
    roundRobin: "Ipamahagi ang handoff nang paikot",
    roundRobinHint: "Pantay na ipamahagi ang mga bagong handoff sa mga miyembro ng team.",
    create: "Gumawa ng team",
    save: "I-save ang team",
    created: "Nagawa ang team na “{{name}}”",
    saved: "Na-save ang team na “{{name}}”",
    delete: "Burahin ang team",
    deleted: "Nabura ang team na “{{name}}”",
    actions: "Mga aksyon para sa {{name}}",
  },
};
